// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Blueprint(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Blueprint" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 3V21H22V10H17V3H2ZM10.5 7.5V5.5H14.5V12.5H19.5V18.5H10.5V15H8V18.5H4.5V12.5H10.5V10H4.5V5.5H8V7.5H10.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Blueprint.js.map